import { Controller } from "@hotwired/stimulus"

// Clear shows once two or more filters are applied, and clears them all in
// one go: each filter hears a single change, so a page that applies filters
// instantly refreshes once. The change comes from the last pick, which is in
// the full list rather than a copy at the top that may have just been redrawn.
export default class extends Controller {
  static targets = ["clear"]

  connect() {
    this.observer = new MutationObserver(() => this.refresh())
    this.observer.observe(this.element, { subtree: true, childList: true, attributes: true, attributeFilter: ["data-applied"] })
    this.refresh()
  }

  disconnect() {
    this.observer.disconnect()
  }

  refresh() {
    this.clearTarget.hidden = this.element.querySelectorAll("[data-applied]").length < 2
  }

  clear() {
    this.element.querySelectorAll("[data-controller~='select-filter']").forEach(filter => {
      const picked = [...filter.querySelectorAll("[role='menu'] input:checked")]
      picked.forEach(input => { input.checked = false })
      picked.at(-1)?.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
